module.exports = "<div class=c-basket__expires ng-if=$ctrl.shouldDisplayDate()> Your basket is valid until <br ng-if=!$ctrl.displayInline> <span>{{ $ctrl.displayDate }}</span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/expiresAt.html
// module id = 692
// module chunks = 0